var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('div',{staticClass:"bg_dimmed",style:({
    display: _vm.visible ? 'block' : 'none',
    background: _vm.visibleOfferwall ? 'rgba(0, 0, 0, 0.8)' : ''
  })},[(_vm.visibleOfferwall)?_c('offerwall'):_vm._e()],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }